import type { GenericHandlerConfig } from './Generic';

export enum State {
    STOPPED = 'STOPPED',
    PLAYING = 'PLAYING',
    PAUSED = 'PAUSED',
}

export enum Media {
    Ended = 'mc-ended',
}

export type SimpleHandlerConfig = GenericHandlerConfig & {
    videoUrl: string;
};
